export default "__VITE_ASSET__sya548_p__ 640w, __VITE_ASSET__BppAG7Re__ 1024w, __VITE_ASSET__yPK9LXNE__ 1280w";